import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import HeaderHome from "../headers/headerHome";
import {UserContext} from "../userContext/userContext";
import * as API from "../services/API";
import Loader from "../layout/Loader";
import Footer from "../components/Footer";
import { FaEye, FaRegEyeSlash } from "react-icons/fa";
import "../css/Login.css";


function Login(){
	const { userDispatch } = useContext(UserContext);
	const [loading, setLoading] = useState(false);
	const [viewPassword, setViewPassword] = useState(false);
	const [error, setError] = useState(false);
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const history = useHistory();
	const onSubmit = (event) => {
		event.preventDefault();
		setLoading(true);
		API.LoginRequest(username,password,(res)=>{
			const user = res.data.user;
			userDispatch({
				type: "LOGIN",
				payload: user
			});
			setLoading(false);
			setError(false);
			sessionStorage.setItem("isLogged", JSON.stringify(true));
			localStorage.setItem("firstName",JSON.stringify(user.first_name))
			localStorage.setItem("last_name",JSON.stringify(user.last_name))
			localStorage.setItem("role",JSON.stringify(user.role))
			localStorage.setItem("_id",JSON.stringify(user._id))
			sessionStorage.setItem("jwttoken", res.headers.jwttoken);
			if(user.role === 2){
				history.push("/admin/gestion");
			}else{
				history.push("/ca/home");
			}
		},(res)=>{setLoading(false);setError(true);history.push("/login");})
	};
	const { t } = useTranslation("common");

	return (
		<>
		<HeaderHome />
		{loading ? (
					<Loader />
				) :
				
            <div className="login-page">
				<div className="d-flex justify-content-center align-items-center h-100">
					<div className="login-card">
					<form onSubmit={onSubmit}>
						<div className="form-group">
							<label htmlFor="login">{t("common.__login__")}</label>
							<input
								type="text"
								className="form-control"
								id="login"
								aria-describedby="loginHelp"
								value={username}
								onChange={(e)=>setUsername(e.target.value)}
								name="login"
							/>
							{/* <small id="loginHelp" className="form-text text-muted">
								{errors.login && t("common.__required__")}
							</small> */}
						</div>
						<div className="form-group">
							<div className="input-password">
								<label htmlFor="password">{t("common.__password__")}</label>
								<input
									type={viewPassword ? "text" : "password"}
									className="form-control"
									id="password"
									value={password}
									onChange={(e)=>setPassword(e.target.value)}
									name="password"
									aria-describedby="passwordHelp"
								/>
								<button
									className="view-password"
									type="button"
									onClick={() => setViewPassword(prevViewPassword => !prevViewPassword)}>
									{viewPassword ? <FaRegEyeSlash /> : <FaEye />}
								</button>
								{/* <small id="emailHelp" className="form-text text-muted">
									{errors.password && t("common.__required__")}
								</small> */}
							</div>
						</div>
						<br />
						{error ? <p className="error-msg text-danger">{t("login.__loginError__")}</p> : null}
						<Link to="/forgot-password">
							<p className="form-text button-text">{t("login.__lostPassword__")}</p>
						</Link>
						<br />
						<button type="submit" className="btn btn-primary">
							{t("users.__loginBtn__")}
						</button>
					</form>

					</div>
				</div>
            </div>}
			<Footer />
		</>
	);
}


export default Login;
